import { abortableFetch, useEventCallback } from '@eas/common-web';
import { EvidenceApiUrl } from '@enums';

export function useDeleteAccessoryParticipantDialog() {
  const callApi = useEventCallback((id: string, proposerId: string) => {
    return abortableFetch(
      `${EvidenceApiUrl.ES_FILES}/${id}/participant/${proposerId}`,
      {
        method: 'DELETE',
        headers: new Headers({
          'Content-Type': 'application/json',
        }),
      }
    );
  });

  return {
    callApi,
  };
}
